import { Component, computed, inject, signal } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { ActivatedRoute, Data, RouterModule } from '@angular/router';
import { environment } from '@environment';
import { PlanktonOrigin } from '@models';
import { PlanktonPropertyListComponent } from '../../propertylist/propertylist.component';
import {
  PlanktonOriginAbstractPipe,
  PlanktonOriginIconPipe,
  PlanktonOriginTitlePipe,
} from '@pipes';
import { TitleService } from '@services';

@Component({
  selector: 'app-plankton-origin-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.scss'],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    PlanktonPropertyListComponent,
    PlanktonOriginAbstractPipe,
    PlanktonOriginIconPipe,
    RouterModule
],
})
export class PlanktonOriginItemComponent {
  titleService = inject(TitleService);
  getOriginTitle = new PlanktonOriginTitlePipe().transform;

  kinkoHost = environment.kinkoHost;

  route = inject(ActivatedRoute);

  origin = signal<PlanktonOrigin>(this.route.snapshot.data['origin']);
  title = computed(() => this.getOriginTitle(this.origin()));

  constructor() {
    this.route.data.subscribe((data: Data) => {
      this.origin.set(data['origin']);
      this.titleService.setTitle(this.title());
    });
  }
}
